export const getUserParams = (usernames, key = 'us') =>
  usernames?.length ? `${key}=${usernames.join(',')}` : '';
